// components/business/message-container/components/box/info-tip-box/info-tip-box.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {},

    /**
     * 组件的初始数据
     */
    data: {
        className: 'info-tip-box'
    },

    /**
     * 组件的方法列表
     */
    methods: {

    }
})